import { render, staticRenderFns } from "./ReturnOrdersPrint.vue?vue&type=template&id=395d6c56&"
import script from "./ReturnOrdersPrint.vue?vue&type=script&lang=js&"
export * from "./ReturnOrdersPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
